module.exports = __webpack_public_path__ + "static/media/logo-freshbooks.a7e5292c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-freshbooks.png
// module id = 1300
// module chunks = 17